import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputDropdownComponent } from './input-dropdown.component';
import { EdAssistUIFormsModule } from '../forms';
import { InputDropdownOption } from './input-dropdown-option.interface';
import { EdAssistUIRequiredOptionalComponentModule } from '@edassist-ui/required-optional';

const COMPONENTS = [InputDropdownComponent];

@NgModule({
	imports: [
		EdAssistUIFormsModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		EdAssistUIRequiredOptionalComponentModule
	],
	exports: COMPONENTS,
	declarations: COMPONENTS
})
class EdAssistUIInputDropdownModule {}

export {
	EdAssistUIInputDropdownModule,
	InputDropdownComponent,
	InputDropdownOption
};
